import React from "react";
import AboutCards from "./AboutCards";
import rocket from "../../assets/img/about/rockets.png";
import rocketLine from "../../assets/img/about/rocket-line.png";
import team from "../../assets/img/about/about-team.png";

const AboutContent = () => {
  return (
    <div>
      <section className="bg-dark-denim md:pb-28 relative">
        <div className="test">
          <div className="app-forager-international-about with-curved-bottom bg-no-repeat bg-cover px-0 pt-5">
            <div className="h-48 md:h-44 lg:mt-14 grid place-items-center">
              <h1 className="text-white text-4xl lg:text-6xl">about</h1>
            </div>
          </div>
        </div>
        <div className="container mx-auto grid grid-cols-1 lg:grid-cols-7 justify-center items-center gap-x-8 mt-14 relative">
          <img
            src={rocket}
            alt=""
            className="hidden lg:block absolute -top-16 left-12 w-1/3 -rotate-[4deg] xl:-rotate-3 2xl:-rotate-2"
          />
          <figure className="lg:col-span-3 mx-auto px-4 mb-10 lg:mb-0 text-white">
            <blockquote>
              <p className="pr-0.5 lg:tracking-[0.01em] xl:pl-10">
                “There’s no point in starting a business unless you’re going to
                make a dramatic difference to other people’s lives. So if you’ve
                got an idea that’s gonna make a big difference to other people’s
                lives, then just get on and do it.”
              </p>
            </blockquote>
            <figcaption className="text-right font-semibold mt-7 pr-5">
              ― Richard Branson
            </figcaption>
          </figure>
          <div
            className="lg:col-span-4 w-full h-[24rem] mx-auto md:rounded-lg"
            style={{
              backgroundImage: `url(${team})`,
            }}
          />
        </div>
      </section>
      <div className="grid grid-cols-1 md:grid-cols-5 justify-center gap-x-9 gap-y-20  mt-14 lg:mt-32 items-center container mx-auto pb-14 lg:pb-28">
        <div className="md:col-span-3 hidden order-1 lg:flex justify-center items-center gap-6">
          <div className="w-full h-40 md:h-64 mx-auto">
            <img
              src={require("../../assets/img/about/night-world.png")}
              alt=""
              className="h-full w-full object-cover rounded-xl"
            />
          </div>
          <div className="w-full h-40 md:h-64 mx-auto">
            <img
              src={require("../../assets/img/about/idea.png")}
              alt=""
              className="h-full w-full object-cover rounded-xl"
            />
          </div>
        </div>
        <div className="col-span-5 lg:col-span-2 order-1 md:order-2 px-4">
          <h2 className="mb-5 text-2xl text-navy-blue font-semibold">
            the story until now
          </h2>
          <p className="tracking-tight">
            Forager International launched its first brand back in 2013 with
            Forager Farms, and its wild-harvested tea brand, Voyageur Teas.
            Since relaunching in 2017, it has been dedicated to building brands
            that specialize in bringing innovative products and solutions to
            market with a heritage focus. Now managing investments in Canada and
            Ireland, the network continues to grow.
          </p>
        </div>
        <div className="order-2 lg:order-4 col-span-5 lg:col-span-3">
          <div className="w-full h-80 md:h-80 mx-auto">
            <img
              src={require("../../assets/img/about/forager-international-about-town.png")}
              alt=""
              className="h-full w-full object-cover lg:rounded-xl"
            />
          </div>
        </div>
        <div className="col-span-5 lg:col-span-2 order-3 md:order-3 px-4 lg:px-0 ml-auto">
          <h2 className="mb-5 text-2xl text-navy-blue font-semibold">
            a specialization in heritage
          </h2>
          <p className="mb-5">
            Forager International’s founder, Bryce Mathew Watts, is an
            anthropologist and ethnobotanist by training, and his passion for
            this field and the drive to be self-sufficient pushed him into
            innovative community development projects working directly with
            heritage organizations.
          </p>
          <p>
            Seeing an opportunity to develop a business model that focuses on
            partnerships and providing quality collaborative services to the
            heritage sector, Bryce began az journey of consultation with
            organizations. The consultation was to see what needs there were in
            the sector and how Forager could develop something to build a
            stronger sector that begins to flex its muscle a bit more when it
            comes to showcasing its economic, tourism, and cultural value.
          </p>
        </div>
      </div>
      <AboutCards />
      <div className="container mx-auto flex pb-32 items-center">
        <img
          src={rocketLine}
          alt=""
          className="hidden lg:block w-1/2 h-full lg:pr-20"
        />
        <p className="px-4 lg:px-0 lg:w-1/2 ml-auto">
          Forager International seeks to innovate and disrupt the intersection
          between for-profit and not-for-profit. We know there are many ways of
          doing business, but believe that a model that values relationships
          with stakeholders and developing revenue streams for organizations to
          become self-reliant is one that can produce amazing results while
          strengthening local communities in a culturally sensitive way.
        </p>
      </div>
    </div>
  );
};

export default AboutContent;
